import Vue from 'vue'
// 自定义指令
export let flex = Vue.directive('flex', {
  bind: function (el) {
    el.style.display = 'flex'
    el.style.alignItems = 'center'
    el.style.justifyContent = 'center'
  }
})
